<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Ofrendas / Listado de Ofrendas</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">Detalle de Ofrendas</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12 border-2">
    <div class="grid" v-if="venta.estado == 0">
      <div class="field col-12 md:col-12 text-right">
        <span
          class="p-tag p-tag-danger"
          style="font-size: 1.2rem; font-weight: bold"
        >
          <i class="pi pi-times"></i>&nbsp; ANULADO
        </span>
      </div>
    </div>
    <div class="grid justify-content-center mb-2">
      <div class="text-center">
        <span style="font-size: 1.6rem; font-weight: bold"
          >DETALLE DE OFRENDA: #{{ venta.id }}</span
        ><br />
        <span
          ><strong>({{ venta.caja?.nombre_sucursal }})</strong></span
        >
      </div>
    </div>
    <div
      class="grid border-bottom-3"
      style="
        background-color: #f8f9fa;
        border-radius: 5px;
        border: 1px solid black;
      "
    >
      <div class="col-6">
        <p class="mb-0">
          <strong>PARROQUIA: </strong>
          <span>{{ venta.caja?.nombre_sucursal }}</span>
        </p>
        <p class="mb-0" v-if="venta.nombre_parroquia">
          <strong>SOLICITANTE: </strong>
          <span>{{ venta.nombre_parroquia }}</span>
        </p>
        <p class="mb-0" v-else>
          <strong>RAZ&Oacute;N SOCIAL: </strong>
          <span>{{ venta.razon_social }}</span>
        </p>
        <p class="mb-0" v-if="false">
          <strong>NIT/CI: </strong> <span>{{ venta.nit }}</span>
        </p>
        <!-- <p class="mb-0">
          <strong>NRO. FACTURA: </strong>
          <span>{{ venta.nrofactura }}</span>
        </p> -->
        <p v-if="tipo_negocio == 2">
          <!-- CardWash -->
          <strong>PLACA: </strong>
          <span>{{
            venta["vehiculo"] ? venta["vehiculo"]["placa"] : "-"
          }}</span>
        </p>
        <p class="mb-0" v-if="venta.observacion">
          <strong>OBSERVACI&Oacute;N: </strong>
          <span>{{ venta.observacion }}</span>
        </p>
        <p class="mb-0" v-if="venta.confirmante">
          <strong>CONFIRMANTE: </strong>
          <span>{{ venta.confirmante }}</span>
        </p>
      </div>
      <div class="col-6">
        <p class="mb-0">
          <strong>FECHA OFRENDA: </strong>
          <span>{{ venta.fecha_venta }}</span>
        </p>
        <p class="mb-0" v-if="tipo_negocio == 2">
          <strong>REALIZADO POR: </strong>
          <span>{{ venta.nombre_medico ?? "-" }}</span>
        </p>
        <p class="mb-0">
          <strong>USUARIO: </strong>
          <span>{{ venta.nombre_usuario_caja }}</span>
        </p>
      </div>
    </div>
    <div class="grid mt-2">
      <DataTable
        ref="ventas"
        :value="productosConDesgloseVisual"
        class="col-12 p-datatable-sm"
        showGridlines
      >
        <Column header="#">
          <template #body="slotProps">
            <span v-if="slotProps.data.indexDisplay">
              {{ slotProps.data.indexDisplay }}
            </span>
            <span v-else>&nbsp;</span>
          </template>
        </Column>

        <Column
          field="pivot.cantidad"
          header="CANTIDAD"
          style="text-align: right"
        >
          <template #body="slotProps">
            {{ convertirNumeroGermanicFormat(slotProps.data.pivot.cantidad) }}
          </template>
        </Column>

        <Column
          field="descripcion"
          header="PRODUCTO/SERVICIO"
          style="font-weight: bold"
        >
          <template #body="slotProps">
            <div
              :class="{
                'pl-3': slotProps.data.esDesglose,
                'text-primary-600': !slotProps.data.esDesglose,
              }"
            >
              <span v-if="slotProps.data.esDesglose">↳ </span>
              {{ slotProps.data.descripcion }}
              <span
                v-if="slotProps.data.pivot?.mes_curia"
                class="bg-blue-100 px-1 rounded"
              >
                • {{ slotProps.data.pivot.mes_curia }}
              </span>
            </div>
          </template>
        </Column>
        <Column field="pivot.observacion" header="OBSERVACIÓN"></Column>

        <Column field="pivot.precio" header="APORTE" style="text-align: right">
          <template #body="slotProps">
            {{ convertirNumeroGermanicFormat(slotProps.data.pivot.precio) }}
          </template>
        </Column>

        <Column
          field="pivot.descuento_neto"
          header="DESCUENTO"
          style="text-align: right"
        >
          <template #body="slotProps">
            {{
              convertirNumeroGermanicFormat(
                slotProps.data.pivot.descuento_neto ?? 0
              )
            }}
          </template>
        </Column>

        <Column header="SUBTOTAL" style="text-align: right">
          <template #body="slotProps">
            {{
              convertirNumeroGermanicFormat(
                slotProps.data.pivot.cantidad * slotProps.data.pivot.precio -
                  (slotProps.data.pivot.descuento_neto || 0)
              )
            }}
          </template>
        </Column>

        <template #footer>
          <div class="text-lg flex align-items-end justify-content-end">
            <div class="text-lg flex align-items-end justify-content-end">
              <span
                >SUBTOTAL: {{ convertirNumeroGermanicFormat(subtotal) }}</span
              >
            </div>
          </div>
          <div
            class="text-lg flex align-items-end justify-content-end"
            v-if="venta.descuento > 0"
          >
            <span
              >DESC.: {{ convertirNumeroGermanicFormat(venta.descuento) }}</span
            >
          </div>
          <div class="flex align-items-end justify-content-end">
            <span class="metodos-pago">
              <strong>EFECTIVO:</strong>
              {{ convertirNumeroGermanicFormat(venta.calculo_efectivo) }}
            </span>
            <br />
          </div>
          <div class="flex align-items-end justify-content-end">
            <span class="metodos-pago">
              <strong>QR:</strong>
              {{ convertirNumeroGermanicFormat(venta.total_venta_qr) }}
            </span>
          </div>
          <div class="flex align-items-end justify-content-end" v-if="false">
            <span class="metodos-pago">
              <strong>TARJETA:</strong>
              {{ convertirNumeroGermanicFormat(venta.total_venta_tarjeta) }}
            </span>
          </div>
          <div
            v-if="venta.tipo_pago_id != 1"
            class="text-lg flex align-items-end justify-content-end"
          >
            <span
              >A CUENTA:
              {{ convertirNumeroGermanicFormat(venta.total_pagos) }}
            </span>
          </div>
          <div
            v-if="venta.tipo_pago_id != 1"
            class="text-lg flex align-items-end justify-content-end"
          >
            <span
              >RECARGO:
              {{ convertirNumeroGermanicFormat(venta.monto_interes_total) }}
            </span>
          </div>
          <div class="text-lg flex align-items-end justify-content-end">
            <span
              >MONTO {{ venta.tipo_pago_id == 1 ? "APORTE" : "DEBE" }} Bs :
              {{
                convertirNumeroGermanicFormat(
                  venta.tipo_pago_id == 1
                    ? venta.total_cancelar
                    : venta.total_cancelar - venta.total_pagos
                )
              }}
            </span>
          </div>
          <div
            v-if="venta.tipo_pago_id != 1"
            class="text-lg flex align-items-end justify-content-end"
          >
            <span
              >TOTAL VENTA:
              {{ convertirNumeroGermanicFormat(venta.total_venta_interes) }}
            </span>
          </div>
        </template>
      </DataTable>
    </div>
    <div class="grid mt-2 justify-content-end">
      <Button
        @click="goBack"
        class="p-button-primary p-button-lg"
        v-tooltip.top="'Volver a Ofrendas'"
      >
        <i class="pi pi-arrow-left"></i>&nbsp;ATR&Aacute;S
      </Button>
      <Button
        v-if="printerName"
        label="IMPRIMIR"
        icon="pi pi-print"
        class="p-button-lg p-button-warning ml-2"
        v-tooltip.top="'Imprimir Ofrenda'"
        @click="imprimirDirecto(venta.id)"
        :loading="imprimiendoDirecto"
      ></Button>
      <Button
        :label="venta.facturado == 1 ? 'IMPRIMIR FACTURA' : 'DESCARGAR PDF'"
        icon="pi pi-file-pdf"
        class="p-button-lg p-button-danger ml-2"
        v-tooltip.top="'Imprimir PDF'"
        @click="imprimirVenta(venta.id)"
        :disabled="imprimiendo"
        :loading="imprimiendo"
      >
      </Button>
      <Button
        v-show="false"
        :label="enviando_whatsapp ? 'ENVIANDO...' : 'ENVIAR'"
        icon="pi pi-whatsapp"
        class="p-button-lg p-button-success ml-2"
        v-tooltip.top="'Enviar por WhatsApp'"
        @click="enviarWhatsApp(venta)"
        :disabled="enviando_whatsapp"
      >
      </Button>
    </div>
  </div>
</template>

<script>
import VentaService from "@/service/VentaService";
import { useAuth } from "@/stores";

export default {
  data() {
    return {
      venta: {},
      venta_id: this.$route.params.id,
      productos: [],
      imprimiendo: false,
      enviando_whatsapp: false,
      tipo_negocio: null,
      imprimiendoDirecto: false,
      printerName: "",
    };
  },
  ventaService: null,
  auth: null,
  created() {
    this.ventaService = new VentaService();
    this.auth = useAuth();
  },
  mounted() {
    this.cargarVenta();
  },
  computed: {
    /* subtotal() {
      let subtotal = 0;
      this.productos.forEach((producto) => {
        subtotal += producto.pivot.precio * producto.pivot.cantidad;
      });
      return subtotal;
    }, */
    productosConDesgloseVisual() {
      let indexCounter = 1;
      const productosParaVisualizacion = [];

      this.productos.forEach((producto) => {
        const esCuria = producto.descripcion.toLowerCase().includes("curia");
        const montoTotal =
          producto.pivot.cantidad * producto.pivot.precio -
          (producto.pivot.descuento_neto || 0);

        // 1. Ítem principal (visualización como 90%)
        productosParaVisualizacion.push({
          ...producto,
          descripcion: esCuria
            ? `${producto.descripcion} (90%)`
            : producto.descripcion,
          pivot: {
            ...producto.pivot,
            // Solo para visualización, no afecta BD
            precio: esCuria
              ? (montoTotal * 0.9) / producto.pivot.cantidad
              : producto.pivot.precio,
            descuento_neto: 0,
          },
          esDesglose: false,
          indexDisplay: indexCounter++,
        });

        if (esCuria) {
          // Fondo del Clero (10%)
          productosParaVisualizacion.push({
            ...producto,
            descripcion: "Fondo del Clero (10%)",
            pivot: {
              ...producto.pivot,
              precio: (montoTotal * 0.10) / producto.pivot.cantidad,
              descuento_neto: 0,
            },
            esDesglose: true,
            indexDisplay: "",
          });
        }
      });

      return productosParaVisualizacion;
    },

    // Mantener cálculos originales basados en 100%
    subtotal() {
      return this.productos.reduce((total, producto) => {
        return (
          total +
          (producto.pivot.cantidad * producto.pivot.precio -
            (producto.pivot.descuento_neto || 0))
        );
      }, 0);
    },
  },
  methods: {
    imprimirDirecto(id) {
      if (this.imprimiendoDirecto) return;

      this.imprimiendoDirecto = true;

      this.ventaService
        .imprimirDirecto(id, this.printerName)
        .then(() => {})
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error.message || "No se pudo imprimir.",
            life: 4000,
          });
        })
        .finally(() => {
          this.imprimiendoDirecto = false;
        });
    },
    enviarWhatsApp(datos) {
      this.enviando_whatsapp = true;
      this.ventaService
        .enviarWhatsApp(datos)
        .then((datos) => {
          if (datos.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: datos.message,
              life: 3000,
            });
            this.enviando_whatsapp = false;
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Éxito",
              detail: datos.message,
              life: 3000,
            });
            this.enviando_whatsapp = false;
          }
        })
        .catch((error) => console.log(error));
    },
    imprimirVenta(id) {
      if (this.imprimiendo) {
        return;
      }
      this.imprimiendo = true;
      this.ventaService.imprimirVenta(id).then(() => {
        this.imprimiendo = false;
      });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero);
    },
    cargarVenta() {
      this.ventaService.getVenta(this.venta_id).then((response) => {
        this.venta = response.venta;
        this.tipo_negocio = response.tipo_negocio;
        this.productos = this.venta.productos;
        this.printerName = response.printerName;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.metodos-pago {
  border: 1px solid #d0d0d0;
}
.pl-3 {
  padding-left: 1rem;
}
.text-primary-600 {
  color: #2563eb;
}

/* Estilo para filas desglosadas */
:deep(.p-datatable .p-datatable-tbody > tr.row-desglose) {
  background-color: #f8f9fa;
}

:deep(.p-datatable .p-datatable-tbody > tr.row-desglose:hover) {
  background-color: #e9ecef;
}
</style>
